import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { IntervalCode } from '@ninety/platform/models/issues/interval-code';

/**
 * Cross-module layouts and issues-v2 events/actions
 *
 * These actions are shared between the layouts and issues-v2 modules to avoid circular dependencies.
 * Issues trash is an in-page mode of the issues list that is entered/exited from the shared layout
 * chrome (filters toolbar / top toolbar), so those events live here and are handled by issues-v2.
 */
export const LayoutsIssuesEvents = createActionGroup({
  source: 'Layouts Issues Events',
  events: {
    // Trash is an in-page mode of the issues list; the interval comes from the active tab's route.
    'Show Trash Items': emptyProps(),
    // Fired by the header "Back to …" button and when the issues page unmounts (next visit starts on the live list).
    'Hide Trash Items': emptyProps(),
    // Archive tab's Type pill lives in the shared filters toolbar; issues-v2 handles the change.
    // 'all' spans both intervals. `IntervalCode` is a low-layer model both libs already depend on.
    'Archive Type Filter Changed': props<{ intervalCode: IntervalCode | 'all' }>(),
  },
});
